import { useEventCallback } from '@cian/react-utils';
import { clamp } from '../../../../../../internal/utils';
import { setValueIndex, roundValueToStep, asc } from '../../../helpers';
export function useSliderValueThumbsKeyDownEvent(_ref) {
  let {
    props,
    valueState,
    marks,
    setFocusIndex,
    setFocusVisibleIndex
  } = _ref;
  return useEventCallback(event => {
    const {
      step,
      min,
      max
    } = props;
    const {
      valueDerived,
      values,
      changeValue,
      range
    } = valueState;
    const index = Number(event.currentTarget.getAttribute('data-index'));
    const value = values[index];
    const tenPercents = (max - min) / 10;
    const marksValues = marks.map(mark => mark.value);
    const marksIndex = marksValues.indexOf(value);
    let newValue;
    const increaseKey = 'ArrowRight';
    const decreaseKey = 'ArrowLeft';
    switch (event.key) {
      case 'Home':
        newValue = min;
        break;
      case 'End':
        newValue = max;
        break;
      case 'PageUp':
        if (step) {
          newValue = value + tenPercents;
        }
        break;
      case 'PageDown':
        if (step) {
          newValue = value - tenPercents;
        }
        break;
      case increaseKey:
      case 'ArrowUp':
        if (step) {
          newValue = value + step;
        } else {
          newValue = marksValues[marksIndex + 1] || marksValues[marksValues.length - 1];
        }
        break;
      case decreaseKey:
      case 'ArrowDown':
        if (step) {
          newValue = value - step;
        } else {
          newValue = marksValues[marksIndex - 1] || marksValues[0];
        }
        break;
      default:
        return;
    }

    // Prevent scroll of the page
    event.preventDefault();
    if (step) {
      newValue = roundValueToStep(newValue, step, min);
    }
    newValue = clamp(newValue, min, max);
    if (range) {
      const previousValue = newValue;
      newValue = setValueIndex({
        values,
        source: valueDerived,
        newValue,
        index
      }).sort(asc);
      setFocusIndex(newValue.indexOf(previousValue));
    }
    setFocusVisibleIndex(index);
    changeValue(newValue);
  });
}